var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.copyToShow,
          expression: "copyToShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _c("div", { staticClass: "content", attrs: { id: "CopyTo" } }, [
        _c("div", { staticClass: "title" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("language.common.copyTo")))]),
          _vm._v(" "),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                return _vm.closeTreeDialog()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            ref: "copyTree",
            staticClass: "task-content"
          },
          [
            _c(
              "el-scrollbar",
              { ref: "elscrollbar", staticStyle: { height: "100%" } },
              [
                !_vm.model.length && !_vm.loading
                  ? _c(
                      "div",
                      {
                        staticClass: "nondrive-des",
                        on: {
                          click: function($event) {
                            return _vm.toAddCloudPage()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "language.popup.cloudTransferPopup.addValidCloud"
                              )
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tree-nodes" },
                  _vm._l(_vm.model, function(item, index) {
                    return _c(
                      "ul",
                      { key: index },
                      [
                        _c("tree", {
                          ref: "tree",
                          refInFor: true,
                          attrs: {
                            model: item,
                            index: index,
                            treeShow: true,
                            transferAimFlag: "CopyTo"
                          }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "task-footer" }, [
          _c("div", {
            staticClass: "icon-util nocheck move-position",
            class: [_vm.$store.state.multiSelect == true ? "check" : ""],
            on: {
              click: function($event) {
                return _vm.multi($event)
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "multi-select" }, [
            _vm._v(_vm._s(_vm.$t("language.common.multiSelect")))
          ]),
          _vm._v(" "),
          _vm.isEmails
            ? _c("div", { staticClass: "multi-select email-options" }, [
                _c("div", { staticClass: "icon-util setting" }),
                _vm._v(" "),
                _c("div", { staticStyle: { margin: "0 5px 0 5px" } }, [
                  _vm._v(_vm._s(_vm.$t("language.common.options")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "icon-util drop-down" }),
                _vm._v(" "),
                _c("div", { staticClass: "email-options-items" }, [
                  _c("div", { staticClass: "email-paste-option" }, [
                    _c("div", {
                      staticClass: "icon-util",
                      class: _vm.options.isSaveAtt
                        ? "check-small"
                        : "nocheck-small-blue",
                      on: {
                        click: function($event) {
                          _vm.options.isSaveAtt = !_vm.options.isSaveAtt
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(_vm._s(_vm.$t("language.emailTransfer.saveAtt")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "email-paste-option" }, [
                    _c("div", {
                      staticClass: "icon-util",
                      class: _vm.options.isConver
                        ? "check-small"
                        : "nocheck-small-blue",
                      on: {
                        click: function($event) {
                          _vm.options.isConver = !_vm.options.isConver
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("language.emailTransfer.converFormat"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "icon-util question-mark" }, [
                      _c("div", { staticClass: "plan-questionTxt" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("language.emailTransfer.converFormatTip")
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "email-paste-option" }, [
                    _c("div", {
                      staticClass: "icon-util",
                      class: _vm.options.isSaveOnly
                        ? "check-small"
                        : "nocheck-small-blue",
                      on: {
                        click: function($event) {
                          _vm.options.isSaveOnly = !_vm.options.isSaveOnly
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(_vm._s(_vm.$t("language.emailTransfer.saveOnly")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "email-paste-option" }, [
                    _c("div", {
                      staticClass: "icon-util",
                      class: _vm.options.delWatermark
                        ? "check-small"
                        : "nocheck-small-blue",
                      on: {
                        click: function($event) {
                          _vm.options.delWatermark = !_vm.options.delWatermark
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticStyle: { float: "left" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.paySystem.freePlanPopup.itemTitle_watermark"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "icon-util vip",
                      staticStyle: { float: "left", margin: "0 5px" }
                    })
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "task-button",
              on: {
                click: function($event) {
                  return _vm.startCopyTo()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce78538e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce78538e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/cloud_exploer_popups/copy_to_popup.vue
// module id = null
// module chunks = 